import React from 'react';
import { IconButton, Box } from '@mui/material';
import { Brightness4, Brightness7 } from '@mui/icons-material';
import { useAppTheme } from '../App';

const ThemeToggle: React.FC = () => {
    const { isDarkMode, toggleTheme } = useAppTheme();

    return (
        <Box
            sx={{
                position: 'relative',
                display: 'inline-flex',
                alignItems: 'center',
            }}
        >
            <IconButton
                onClick={toggleTheme}
                sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 3,
                    color: isDarkMode ? '#fbbf24' : '#6b7280',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                        backgroundColor: isDarkMode
                            ? 'rgba(251, 191, 36, 0.1)'
                            : 'rgba(107, 114, 128, 0.1)',
                        transform: 'scale(1.05)',
                    },
                }}
            >
                {isDarkMode ? (
                    <Brightness7 sx={{ fontSize: 24 }} />
                ) : (
                    <Brightness4 sx={{ fontSize: 24 }} />
                )}
            </IconButton>
        </Box>
    );
};

export default ThemeToggle; 